<template>
  <div class="declaration">
    <common-head title="疫苗告知书" />
    <div class="my-wrap">
      <div class="my-html" v-html="context"></div>
    </div>
    <div class="my-button">
      <van-button type="info" round :disabled="seconds >= 0" @click="enetrPickDate">
        我已阅读
        <span v-if="seconds >= 0">({{ seconds }}s)</span>
      </van-button>
    </div>
  </div>
</template>

<script>
import CommonHead from 'components/CommonHead'
import { fetchDeclaration } from 'api/vacc'

export default {
  components: {
    CommonHead
  },
  data() {
    return {
      seconds: 5,
      context: ''
    }
  },
  created() {
    this.getDeclaration()
  },
  methods: {
    // 获取告知书
    getDeclaration() {
      const { vaccineCode } = this.$route.query
      fetchDeclaration(vaccineCode).then(res => {
        this.context = res.data.context
        // 倒计时
        let timer = setInterval(() => {
          this.seconds --
          if (this.seconds < 0) {
            clearInterval(timer)
          }
        }, 1000)
      })
    },
    enetrPickDate() {
      this.$router.push({
        path: 'pick-date',
        query: {
          povCode: this.$route.query.povCode
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.declaration {
  padding-bottom: 81px;
}
</style>